const JobStatuses = {
    0: {
        type: 'processing',
        displayedName: 'Open',
        toolTip: 'Job is open and ready to be processed',
    },
    1: {
        type: 'processing',
        displayedName: 'In Progress',
        toolTip: 'Job is currently being processed',
    },
    2: {
        type: 'active',
        displayedName: 'Completed',
        toolTip: 'Job has been successfully completed',
    },
    3: {
        type: 'inactive',
        displayedName: 'Cancelled',
        toolTip: 'Job was cancelled',
    },
    20: {
        type: 'error',
        displayedName: 'Error',
        toolTip: 'Job encountered an error during processing',
    },
};

export default JobStatuses;
